export default __webpack_public_path__ + "static/media/social-4.fe48bb11.png";